import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NotFoundPageComponent } from './pages/not-found-page/not-found-page.component';
import { MainLayoutComponent } from './layouts/main/main.component';
import { MainLayoutModule } from './layouts/main/main.module';
import { NotFoundPageModule } from './pages/not-found-page/not-found-page.module';
import { AuthGuard } from './guards/auth.guard';
import { IsAdminGuard } from './guards/is-admin.guard';
import { IsDetectorGuard } from './guards/is-detector.guard';
import { ServerErrorPageComponent } from './pages/server-error-page/server-error-page.component';
import { ServerErrorPageModule } from './pages/server-error-page/server-error-page.module';

const routes: Routes = [
  { path: 'welcome', redirectTo: 'personas', pathMatch: 'full' },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'login',
    loadChildren:
      './features/sign-in/routes/sign-in.routing#SignInRoutingModule',
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthGuard, IsDetectorGuard],
    children: [
      {
        path: 'listas',
        loadChildren:
          './features/lists/routes/lists.routing#ListsRoutingModule',
      },
      {
        path: 'personas',
        loadChildren:
          './features/people/routes/people.routing#PeopleRoutingModule',
      },
      {
        path: 'monitoreo',
        canActivate: [IsAdminGuard],
        loadChildren:
          './features/monitoring/routes/monitoring.routing#MonitoringRoutingModule',
      },
      {
        path: 'deteccion',
        loadChildren:
          './features/detection/routes/detection.routing#DetectionRoutingModule',
      },
      {
        path: 'usuarios',
        loadChildren:
          './features/users/routes/users.routing#UsersRoutingModule',
      },
      {
        path: 'analiticas',
        loadChildren:
          './features/analytics/routes/analytics.routing#AnalyticsRoutingModule',
      },
      {
        path: 'auditorias',
        loadChildren:
          './features/audits/routes/audits.routing#AuditsRoutingModule',
      },
    ],
  },
  { path: '500', component: ServerErrorPageComponent },
  { path: '**', component: NotFoundPageComponent },
];

@NgModule({
  imports: [
    MainLayoutModule,
    NotFoundPageModule,
    ServerErrorPageModule,
    RouterModule.forRoot(routes),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
